import AuthService from '../../shared/services/AuthService';
import { CommentModel } from '../../assessments/models/CommentModel';
import MembershipService from '../../membership/services/MembershipService';

class CommentService {
  public getMarkername(comment: CommentModel) {
    if (comment) {
      const assignedToMe = comment.userkey === AuthService.Userkey;
      const marker = `${comment.firstname} ${comment.lastname}`;
      return assignedToMe ? `${marker} (Me)` : marker;
    }
    return '';
  }
}

export default new CommentService();
